import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import InputComponent from "../InputComponent";
import { useAuth } from "../../contexts/AuthContext";
import {
  addDoc,
  collection,
  serverTimestamp,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import DropDownComponentSorted from "../DropDownComponentSorted";

import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

function AddGroupNote(props) {
  const { currentUser } = useAuth();

  //Tous les states des données récupérées par client

  const [isLoading, setIsLoading] = useState(false);
  const [typeGroupNote, setTypeGroupNote] = useState("");
  const [groupTopic, setGroupTopic] = useState("");
  const [noteContent, setNoteContent] = useState("");
  const [notInAttendance, setNotInAttendance] = useState("");
  const [otherTypeGroupNote, setOtherTypeGroupNote] = useState("");
  const [groupNoteDateTime, setGroupNoteDateTime] = useState(new Date());
  const [groupNoteStartDateTime, setGroupNoteStartDateTime] = useState(
    new Date()
  );
  const [attendees, setAttendees] = useState([]);
  const [inhouseClients, setInhouseClients] = useState([]);
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const draftKey = `draft:groupNote:${currentUser?.uid || "anon"}:${
    props.clientId || "unknown"
  }`;
  const draftDelay = 800;
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  // useEffect(() => {
  //   recordMetrics("Notes", "groupNotes", currentUser.email, "write", "bodhi");
  // }, []);

  // const handleClose2 = () => setOpen2(false);
  // const [open2, setOpen2] = React.useState(false);

  const handleTypeGroupNote = (event) => {
    setTypeGroupNote(event);
  };

  const handleGroupTopic = (event) => {
    setGroupTopic(event);
  };
  const handleNoteContent = (event) => {
    setNoteContent(event.target.value);
  };

  const handleOtherTypeGroupNote = (event) => {
    setOtherTypeGroupNote(event);
  };

  const handleNotInAttendance = (event) => {
    setNotInAttendance(event.target.value);
  };

  const handleDateTimeChange = (event) => {
    setGroupNoteDateTime(event);
  };

  const handleGroupStartDateTimeChange = (event) => {
    setGroupNoteStartDateTime(event);
  };

  const handleToggleAttendee = (clientId) => {
    setAttendees((prev) =>
      prev.includes(clientId)
        ? prev.filter((id) => id !== clientId)
        : [...prev, clientId]
    );
  };

  const handleAddGroupNote = async (note, effectiveDateTime) => {
    const attendeesDetails = attendees
      .map((id) => {
        const client = inhouseClients.find((c) => c.id === id);
        const name = `${client?.preferredName || client?.firstName || ""} ${
          client?.lastName || ""
        }`
          .trim()
          .replace(/\s+/g, " ");
        return {
          id,
          name: name || "Unnamed client",
        };
      })
      .filter(Boolean);

    const noteData = {
      noteType: "groupNote",
      noteContent: note,
      createdAt: serverTimestamp(),
      effectiveDateTime: effectiveDateTime,
      doneBy: currentUser.displayName,
      notInAttendance: notInAttendance,
      groupTopic: groupTopic,
      typeGroupNote: typeGroupNote,
      otherTypeGroupNote: otherTypeGroupNote,
      groupStartDateTime: groupNoteStartDateTime,
      attendees,
      attendeesDetails,
    };

    if (
      typeGroupNote &&
      groupTopic &&
      noteContent &&
      notInAttendance &&
      groupNoteStartDateTime
    ) {
      setIsLoading(true);
      try {
        await addDoc(collection(db, "notes"), noteData);
        showCustomToast("Group note successfully added!", "success");

        setIsLoading(false);
        try {
          localStorage.removeItem(draftKey);
        } catch {}
        props.closemodal();
      } catch (error) {
        console.log("error adding note :", error);
        showCustomToast("Problem when adding note!", "error");
      }
    } else {
      showCustomToast(
        "Some mandatory fields are empty. Please check.!",
        "error"
      );
    }
  };

  const handleSubmit = () => {
    handleAddGroupNote(noteContent, groupNoteDateTime);
  };

  // Restore draft on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(draftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.text) setNoteContent(parsed.text);
        if (parsed?.typeGroupNote) setTypeGroupNote(parsed.typeGroupNote);
        if (parsed?.groupTopic) setGroupTopic(parsed.groupTopic);
        if (parsed?.notInAttendance) setNotInAttendance(parsed.notInAttendance);
        if (parsed?.otherTypeGroupNote)
          setOtherTypeGroupNote(parsed.otherTypeGroupNote);
        if (parsed?.attendees) setAttendees(parsed.attendees);
        if (parsed?.date) {
          const d = new Date(parsed.date);
          if (!isNaN(d)) setGroupNoteDateTime(d);
        }
        if (parsed?.startDate) {
          const d = new Date(parsed.startDate);
          if (!isNaN(d)) setGroupNoteStartDateTime(d);
        }
      }
    } catch (e) {
      console.warn("GroupNote draft load error:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave draft with debounce
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(
          draftKey,
          JSON.stringify({
            text: noteContent,
            date: groupNoteDateTime?.toISOString?.() || null,
            startDate: groupNoteStartDateTime?.toISOString?.() || null,
            typeGroupNote,
            groupTopic,
            notInAttendance,
            otherTypeGroupNote,
          })
        );
        setIsSavingDraft(false);
      } catch (e) {
        console.warn("GroupNote draft save error:", e);
      }
    }, draftDelay);
    setIsSavingDraft(true);
    return () => clearTimeout(t);
  }, [
    noteContent,
    groupNoteDateTime,
    groupNoteStartDateTime,
    typeGroupNote,
    groupTopic,
    notInAttendance,
    otherTypeGroupNote,
    attendees,
    draftKey,
  ]);

  // Fetch in-house clients once
  useEffect(() => {
    const fetchInhouse = async () => {
      setIsLoadingClients(true);
      try {
        const q = query(
          collection(db, "clients"),
          where("clientStatus", "==", "In House")
        );
        const snap = await getDocs(q);
        const data = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setInhouseClients(data);
      } catch (e) {
        console.error("Failed to load in-house clients for group note", e);
      } finally {
        setIsLoadingClients(false);
      }
    };
    fetchInhouse();
  }, []);

  return (
    <>
      <div
        style={{ width: "auto", height: "100%" }}
        // className="inputAndLabelModalContainerTitle2"
      >
        <div className="line1-modal-percent">
          <div className="modal-title">Add group note</div>
          <CloseIcon
            style={{
              marginRight: "16px",
              color: "rgb(214, 213, 213)",
              cursor: "pointer",
            }}
            onClick={props.closemodal}
          />
        </div>

        <div
          style={{
            width: "100%",
            marginTop: "10px",
            height: "75%",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div
            className="line3-modal-nopad"
            style={{
              paddingLeft: "10px",
              // backgroundColor: "pink",
            }}
          >
            <div style={{ width: "100%", maxWidth: "300px" }}>
              <InputComponent
                isRequired={true}
                value={groupTopic}
                title="Group topic"
                width="auto"
                onChange={handleGroupTopic}
              />
            </div>
          </div>

          <div
            className="line3-modal-nopad"
            style={{
              paddingLeft: "10px",
              // backgroundColor: "pink",
            }}
          >
            <DatePickerWithTimeComponent
              isRequired={true}
              value={groupNoteStartDateTime}
              title="Group Date and start time"
              width="300px"
              onChange={handleGroupStartDateTimeChange}
            />
          </div>

          <div
            className="line3-modal-nopad"
            style={{
              paddingLeft: "10px",
              marginBottom: "10px",
            }}
          >
            <div className="label-textfield" style={{ marginBottom: 6 }}>
              Clients in attendance (optional)
            </div>
            <div
              style={{
                maxHeight: "180px",
                overflowY: "auto",
                background: "#f7f7f9",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "8px 10px",
                width: "50%",
                minWidth: "280px",
              }}
            >
              {isLoadingClients ? (
                <div style={{ color: "#777", fontSize: "14px" }}>
                  Loading in-house clients...
                </div>
              ) : inhouseClients.length === 0 ? (
                <div style={{ color: "#777", fontSize: "14px" }}>
                  No in-house clients found.
                </div>
              ) : (
                inhouseClients.map((client) => {
                  const name = `${client?.preferredName || client?.firstName || ""} ${
                    client?.lastName || ""
                  }`
                    .trim()
                    .replace(/\s+/g, " ");
                  return (
                    <FormControlLabel
                      key={client.id}
                      control={
                        <Checkbox
                          size="small"
                          checked={attendees.includes(client.id)}
                          onChange={() => handleToggleAttendee(client.id)}
                        />
                      }
                      label={name || "Unnamed client"}
                      sx={{ width: "100%", margin: 0, color: "#333" }}
                    />
                  );
                })
              )}
            </div>
          </div>

          <div
            className="line3-modal-nopad"
            style={{
              paddingLeft: "10px",
              // backgroundColor: "pink",
            }}
          >
            <DropDownComponentSorted
              isRequired={true}
              value={typeGroupNote}
              api="groupType"
              title="Type of group"
              onChange={handleTypeGroupNote}
            />

            {typeGroupNote === "Other" ? (
              <InputComponent
                value={otherTypeGroupNote}
                title="if other, describe"
                width="300px"
                onChange={handleOtherTypeGroupNote}
              />
            ) : (
              ""
            )}
          </div>

          <div
            className="line2-column-modal"
            // style={{ backgroundColor: "pink" }}
          >
            <div className="label-textfield">
              Group note
              <span style={{ color: "red", marginLeft: "5px" }}>*</span>
            </div>

            <TextField
              value={noteContent}
              style={{
                width: "95%",
                borderRadius: "5px",
                backgroundColor: "#f2eeef",
              }}
              placeholder="Type group note here"
              multiline
              rows={10}
              onChange={handleNoteContent}
            />
          </div>
          <div
            className="line2-column-modal"
            // style={{ backgroundColor: "pink" }}
          >
            <div className="label-textfield">
              Clients NOT in attendance
              <span style={{ color: "red", marginLeft: "5px" }}>*</span>
            </div>
            <TextField
              value={notInAttendance}
              style={{
                width: "95%",
                borderRadius: "5px",
                backgroundColor: "#f2eeef",
              }}
              placeholder="Type names here (first name / or preferred name and first initial of last name) and reason why client is not in group, if known..."
              // placeholder="Type therapy session note here."
              multiline
              rows={4}
              onChange={handleNotInAttendance}
            />
          </div>
          <div
            className="line3-modal-nopad"
            style={{
              // marginLeft: "20px",
              paddingLeft: "10px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <DatePickerWithTimeComponent
              isRequired={true}
              // therapyNoteDateTime={nonTherapyNoteDateTime}
              value={groupNoteDateTime}
              // setTherapyNoteDateTime={setNonTherapyNoteDateTime}
              onChange={handleDateTimeChange}
              title="Effective date and time"
            />
          </div>
        </div>

        <div
          className="line4-modal-percent"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Chip
            label={
              isSavingDraft
                ? "Saving draft..."
                : noteContent
                ? "Draft saved"
                : "No draft"
            }
            size="small"
            sx={{
              backgroundColor: isSavingDraft
                ? "#f9a825"
                : noteContent
                ? "#2e7d32"
                : "#607d8b",
              color: "#fff",
              fontWeight: 700,
            }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              try {
                localStorage.removeItem(draftKey);
              } catch {}
              setNoteContent("");
              setGroupNoteDateTime(new Date());
              setGroupNoteStartDateTime(new Date());
              setAttendees([]);
            }}
          >
            Clear draft
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
                : {
                    backgroundColor: "#1565C0",
                    color: "white",
                    marginLeft: "15px",
                  }
            }
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "ADDING..." : "ADD NOTE"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddGroupNote;
